<template>
    <div class="validate-account">
        <h1>Validación de Cuenta</h1>
        <div v-if="message" class="alert" :class="{'alert-success': isValid == true, 'alert-danger': isValid != true}">
            {{ message }}
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'ValidateAccountView',
    data() {
        return {
            message: '',
            isValid: false
        };
    },
    created() {
        const token = this.$route.params.token;
        if (token) {
            this.validateAccount(token);
        } else {
            this.message = 'Token inválido.';
        }
    },
    methods: {
        ...mapActions(['validateToken']),
        async validateAccount(token) {
            try {
                // Replace with your actual API endpoint
                let data = await this.validateToken(token);
                if (data) {
                    this.isValid = true;
                    this.message = '¡Cuenta validada con éxito! Ahora puedes iniciar sesión.';
                } else {
                    this.isValid = false;
                    this.message = 'La cuenta no pudo ser validada. Contacta al administrador.';
                }
            } catch (error) {
                this.message = 'Ocurrió un error durante la validación.';
            }
        }
    }
};
</script>

<style scoped>
.validate-account {
    text-align: center;
    margin-top: 50px;
}
</style>